var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.items.length > 0,
              expression: "items.length > 0"
            }
          ],
          staticClass: "col-xs-12"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    id: "checkedListboxSearch" + _vm.field,
                    placeholder: "Escribe tu consulta..."
                  },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                },
                [_vm._v("Buscar")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.items.length > 0,
              expression: "items.length > 0"
            }
          ],
          staticClass: "col-xs-12"
        },
        [
          _c("p", [
            _c("label", { attrs: { for: "seleccionarTodo" + _vm.field } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.todos,
                    expression: "todos"
                  }
                ],
                attrs: { type: "checkbox", id: "seleccionarTodo" + _vm.field },
                domProps: {
                  checked: Array.isArray(_vm.todos)
                    ? _vm._i(_vm.todos, null) > -1
                    : _vm.todos
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.todos,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.todos = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.todos = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.todos = $$c
                      }
                    },
                    _vm.seleccionarTodos
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Seleccionar todo")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.similiarToSearch(item[_vm.label]),
                expression: "similiarToSearch(item[label])"
              }
            ],
            key: index,
            staticClass: "col-xs-12 col-md-6"
          },
          [
            _c(
              "label",
              { attrs: { for: _vm.name.toString() + index.toString() } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.modelValue,
                      expression: "modelValue"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: _vm.name,
                    id: _vm.name.toString() + index.toString()
                  },
                  domProps: {
                    value: item[_vm.field],
                    checked: Array.isArray(_vm.modelValue)
                      ? _vm._i(_vm.modelValue, item[_vm.field]) > -1
                      : _vm.modelValue
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.modelValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = item[_vm.field],
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.modelValue = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.modelValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.modelValue = $$c
                        }
                      },
                      function($event) {
                        return _vm.$emit("input", _vm.modelValue)
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item[_vm.label]))])
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.items.length === 0,
              expression: "items.length === 0"
            }
          ],
          staticClass: "col-xs-12"
        },
        [_c("p", [_vm._v("No hay registros.")])]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05d12cb0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d12cb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/CheckedListbox.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-05d12cb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/CheckedListbox.vue
// module chunks = 0